export default "__VITE_ASSET__DhbMYvJf__"